import React from "react";
import NavBar from "../../components/navBar/NavBar";
import axios from "axios";
import "../../assets/style/style.css";

import swal from "sweetalert";
import Swal from "sweetalert2";
import ReactFileReader from "react-file-reader";
import ImgCard from "../../components/imgCard/ImgCard.jsx";
import Submit from "../../components/submit/Submit";
//import InputMask from "react-input-mask";
import moment from "moment";
require("dotenv").config();
const url = process.env.REACT_APP_API_TASK;
class CheckList extends React.Component {
  state = {
    nivelCombustivelIda: "",

    hora: "",
    data: "",
    destino: "",
    origem: "",
    obs: "",
    kmInicial: "",
    kmFinal: "",
    veiculos: [],
    ImgAmassados: [],
    amassado: "",
    trajetos: "",
    idCheckList: "",
    imgAmassadoFrota: [],
    condutors: [],
    condutor: "",
    load: false
  };
  componentDidMount() {
    this.getVeiculos();
    this.getTecnico();
    this.getDate();
    this.getTime();

    this.getLastCheckListOpen();
  }

  getTecnico = () => {
    const objForm = { token: localStorage.getItem("token") };
    axios
      .post(
        `${url}/tecnicos`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        this.setState({
          condutors: response.data.resulTecnicos
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  getDate = () => {
    if (!this.state.data) {
      this.setState({
        data: moment().format("L")
      });
    }
  };

  getTime = () => {
    if (!this.state.hora) {
      this.setState({
        hora: moment().format("H:mm")
      });
    }
  };

  getVeiculos = () => {
    const objForm = { token: localStorage.getItem("token") };
    axios
      .post(
        `${url}/veiculos`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        this.setState({
          veiculos: response.data.resulVeiculos
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  getLastCheckListOpen = () => {
    const objForm = {
      token: localStorage.getItem("token"),
      tecnico: localStorage.getItem("name")
    };
    axios
      .post(
        `${url}/lastCheckList`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        console.log(response);
        this.setState({ origem: "", destino: "" });

        if (response.data.resultCheckList.length > 0) {
          this.setState({
            trajetos: response.data.resultCheckList.length,
            imgAmassadoFrota: response.data.resultImgAmassado,
            idCheckList:
              response.data.resultCheckList[0].controle_km_PRODUCAO_id,
            data: response.data.resultCheckList[0].data_inicial,
            hora: response.data.resultCheckList[0].hora,
            kmInicial: response.data.resultCheckList[0].km_inicial,
            amassado: response.data.resultCheckList[0].nivel_amassados,
            nivelCombustivelIda:
              response.data.resultCheckList[0].nivel_combustivel,
            obs: response.data.resultCheckList[0].obs,
            veiculoId: response.data.resultCheckList[0].veiculo_id
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleInput = e => {
    let key = e.target.name;
    let value = e.target.value;
    console.log(key + " -- " + value);
    this.setState({
      [key]: value
    });
  };

  salvarCheckList = () => {
    this.setState({
      load: true
    });
    if (
      this.state.nivelCombustivelIda !== "" &&
      this.state.origem !== "" &&
      this.state.destino !== "" &&
      this.state.condutor !== ""
    ) {
      const objForm = {
        token: localStorage.getItem("token"),
        tecnico: localStorage.getItem("name"),
        veiculoId: this.state.veiculoId,
        data: this.state.data,
        hora: this.state.hora,
        amassado: this.state.amassado,
        origem: this.state.origem,
        destino: this.state.destino,
        condutor: this.state.condutor,
        kmInicial: this.state.kmInicial,
        kmFinal: this.state.kmFinal,
        obs: this.state.obs,
        nivelCombustivelIda: this.state.nivelCombustivelIda,
        nivelCombustivelVolta: this.state.nivelCombustivelVolta,
        idCheckList: this.state.idCheckList,
        imgAmassadoFrota: this.state.imgAmassadoFrota
      };
      axios
        .post(
          `${url}/postCheckList`,
          {
            objForm: objForm
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          console.log(response);
          //verificar retorno
          this.setState({ load: false });
          //Swal.fire("Sucesso!", "Dados enviados", "success");

          Swal.fire({
            title: "Sucesso",
            text: "Dados enviados!",
            type: "success",

            confirmButtonColor: "#3085d6"
          }).then(result => {
            if (result.value) {
              window.location.reload();
            }
          });

          this.getLastCheckListOpen();
        })
        .catch(function(error) {
          Swal.fire("Erro!", "Erro ao enviar Dados", "error");
          console.log(error);
        });
    } else if (this.state.nivelCombustivelIda === "") {
      Swal.fire(
        "Campo em Branco",
        "Informe o Nivel do Combutivel de Ida",
        "error"
      );
      this.setState({
        load: false
      });
    } else if (this.state.origem === "") {
      Swal.fire("Campo em Branco", "Informe a Origem", "error");
      this.setState({
        load: false
      });
    } else if (this.state.destino === "") {
      Swal.fire("Campo em Branco", "Informe o Destino", "error");
      this.setState({
        load: false
      });
    } else if (this.state.condutor === "") {
      Swal.fire("Campo em Branco", "Informe o Condutor", "error");
      this.setState({
        load: false
      });
    }
  };

  handleFilesAmassado = files => {
    files.base64.map(file => {
      this.setState({
        imgAmassadoFrota: [...this.state.imgAmassadoFrota, file]
      });
      return true;
    });
  };

  deleteImg = (key, input, bd) => {
    let array = this.state[input];
    if (bd !== true) {
      array.splice(key, 1);
      this.setState({ [input]: array });
    } else {
      swal({
        title: "Você tem Certeza ?",
        text: " Está imagem será deletada!",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancelar", true]
      }).then(willDelete => {
        if (willDelete) {
          if (array[key].img) {
            const objForm = {
              foto: array[key],
              token: localStorage.getItem("token")
            };
            axios
              .post(
                url + "/frota_delete_foto",
                {
                  objForm: objForm
                  //nome : 'bruno'
                },
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                  }
                }
              )
              .then(response => {
                if (response.data === 1) {
                  this.setState({ load: false });
                  swal("Deletado!", "Imagem Deletada!", "success");
                  array.splice(key, 1);
                  this.setState({ img: array });
                } else {
                  swal("Falha!", "Não foi possivel excluir a imagem!", "error");
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        }
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <NavBar />
        <div className="container-fluid container_body">
          <div className="containerCard">
            <div className="card marginTop6">
              <h5 className="card-header">Veículo Verificado</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    Selecione o Veículo
                  </label>

                  <select
                    className="form-control"
                    id="exampleFormControlSelect1"
                    name="veiculoId"
                    onChange={this.handleInput.bind(this)}
                    value={this.state.veiculoId}
                  >
                    {this.state.veiculos.map((item, i) => (
                      <option key={i} value={item.veiculo_id}>
                        [{item.placa}] - {item.modelo} - {item.km_final} KM
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Informações de Data e Hora</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Data</label>
                  {/*
                  <InputMask
                    className="form-control"
                    mask="99/99/9999"
                    value={this.state.data}
                    name="data"
                    //onChange={this.handleInputChange.bind(this)}
                  />
                  */}
                  <input
                    type="text"
                    id="data"
                    name="data"
                    className="form-control"
                    value={this.state.data}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Hora</label>
                  {/*
                  <InputMask
                    className="form-control"
                    //mask="99:99"
                    value={this.state.hora}
                    name="hora"
                    //onChange={this.handleInputChange.bind(this)}
                  />
                  */}
                  <input
                    type="text"
                    id="hora"
                    name="hora"
                    className="form-control"
                    value={this.state.hora}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">
                Itens para Verificação de KM Inicial
              </h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    1. Nível de Combustível Ida
                  </label>

                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="nivelCombustivelIda1"
                      name="nivelCombustivelIda"
                      className="custom-control-input"
                      value="Alto"
                      onChange={this.handleInput.bind(this)}
                      checked={
                        this.state.nivelCombustivelIda &&
                        this.state.nivelCombustivelIda === "Alto"
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="nivelCombustivelIda1"
                    >
                      Alto
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="nivelCombustivelIda2"
                      name="nivelCombustivelIda"
                      className="custom-control-input"
                      onChange={this.handleInput.bind(this)}
                      value="Médio"
                      checked={this.state.nivelCombustivelIda === "Médio"}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="nivelCombustivelIda2"
                    >
                      Médio
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="nivelCombustivelIda3"
                      name="nivelCombustivelIda"
                      className="custom-control-input"
                      onChange={this.handleInput.bind(this)}
                      value="Baixo"
                      checked={this.state.nivelCombustivelIda === "Baixo"}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="nivelCombustivelIda3"
                    >
                      Baixo
                    </label>
                  </div>

                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="combustivel4"
                      name="nivelCombustivelIda"
                      className="custom-control-input"
                      onChange={this.handleInput.bind(this)}
                      value="Reserva"
                      //defaultChecked
                      checked={this.state.nivelCombustivelIda === "Reserva"}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="combustivel4"
                    >
                      Reserva
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    2. Amassados / Arranhões
                  </label>

                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="amassado1"
                      name="amassado"
                      className="custom-control-input"
                      onChange={this.handleInput.bind(this)}
                      value="Antigos"
                      //defaultChecked
                      checked={this.state.amassado === "Antigos"}
                    />
                    <label className="custom-control-label" htmlFor="amassado1">
                      Antigos
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="amassado2"
                      name="amassado"
                      className="custom-control-input"
                      onChange={this.handleInput.bind(this)}
                      value="Novos"
                      checked={this.state.amassado === "Novos"}
                    />
                    <label className="custom-control-label" htmlFor="amassado2">
                      Novos
                    </label>
                  </div>
                  <div className="form-group marginTop6">
                    <ReactFileReader
                      handleFiles={this.handleFilesAmassado}
                      base64={true}
                      multipleFiles={true}
                      ref="fotosNecessaria"
                      name="fotosNecessaria"
                    >
                      <button className="btn btn-primary btn-sm ">
                        Adicionar Foto
                      </button>
                    </ReactFileReader>
                  </div>
                  <div className="form-group containerImg">
                    {this.state.imgAmassadoFrota &&
                      this.state.imgAmassadoFrota.map((img, i) =>
                        img.img ? (
                          <div key={i}>
                            <ImgCard
                              src={url + "/upload/" + img.img}
                              clickDeleteImg={() =>
                                this.deleteImg(i, "imgAmassadoFrota", true)
                              }
                            />
                          </div>
                        ) : (
                          <div key={i}>
                            <ImgCard
                              src={img}
                              clickDeleteImg={() =>
                                this.deleteImg(i, "imgAmassadoFrota")
                              }
                            />
                          </div>
                        )
                      )}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Km Inicial</label>

                  <input
                    type="number"
                    className="form-control"
                    id="inputAddress2"
                    name="kmInicial"
                    onChange={this.handleInput.bind(this)}
                    value={this.state.kmInicial}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Informações de Trajetos</h5>
              <div className="card-body">
                <p>Trajeto #{this.state.trajetos + 1}</p>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Origem</label>
                  <input
                    type="text"
                    className="form-control"
                    id="origem"
                    name="origem"
                    value={this.state.origem}
                    onChange={this.handleInput.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Destino</label>
                  <input
                    type="text"
                    className="form-control"
                    id="destino"
                    name="destino"
                    value={this.state.destino}
                    onChange={this.handleInput.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Condutor</label>
                  <select
                    className="form-control"
                    id="condutor"
                    name="condutor"
                    onChange={this.handleInput.bind(this)}
                  >
                    <option value="" />
                    {this.state.condutors.map((condutor, i) => (
                      <option value={condutor.nome} key={i}>
                        {condutor.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="card marginTop6">
              <h5 className="card-header">Observação</h5>
              <div className="card-body">
                <div className="form-group">
                  <textarea
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    name="obs"
                    onChange={this.handleInput.bind(this)}
                    value={this.state.obs}
                  >
                    {this.state.obs}
                  </textarea>
                </div>
              </div>
            </div>

            {this.state.trajetos !== 0 && (
              <div className="card marginTop6">
                <h5 className="card-header">
                  Itens para Verificação de KM Final
                </h5>
                <div className="card-body">
                  <div className="form-group">
                    <label htmlFor="exampleFormControlSelect1">Km Final</label>
                    <input
                      type="number"
                      className="form-control"
                      id="kmFinal"
                      name="kmFinal"
                      onChange={this.handleInput.bind(this)}
                      value={this.state.kmFinal}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleFormControlSelect1">
                      1. Nível de Combustível Volta
                    </label>
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id="nivelCombustivelIdVolta1"
                        name="nivelCombustivelVolta"
                        className="custom-control-input"
                        value="Alto"
                        onChange={this.handleInput.bind(this)}
                        checked={this.state.nivelCombustivelVolta === "Alto"}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="nivelCombustivelIdVolta1"
                      >
                        Alto
                      </label>
                    </div>
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id="nivelCombustivelIdVolta2"
                        name="nivelCombustivelVolta"
                        className="custom-control-input"
                        onChange={this.handleInput.bind(this)}
                        value="Médio"
                        checked={this.state.nivelCombustivelVolta === "Médio"}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="nivelCombustivelIdVolta2"
                      >
                        Médio
                      </label>
                    </div>
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id="nivelCombustivelIdVolta3"
                        name="nivelCombustivelVolta"
                        className="custom-control-input"
                        onChange={this.handleInput.bind(this)}
                        value="Baixo"
                        checked={this.state.nivelCombustivelVolta === "Baixo"}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="nivelCombustivelIdVolta3"
                      >
                        Baixo
                      </label>
                    </div>
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        id="nivelCombustivelIdVolta4"
                        name="nivelCombustivelVolta"
                        className="custom-control-input"
                        onChange={this.handleInput.bind(this)}
                        value="Reserva"
                        checked={this.state.nivelCombustivelVolta === "Reserva"}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="nivelCombustivelIdVolta4"
                      >
                        Reserva
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="card marginTop6">
              <Submit
                load={this.state.load}
                submitClick={this.salvarCheckList}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CheckList;
